//@flow

import invariant from './invariant';

function abstractMethod<T>(className: string, methodName: string): T {
  invariant(
    false,
     'Subclasses of %s must override %s() with their own implementation.',
     className,
     methodName
   );
}

export default abstractMethod;

// Compatibilité CommonJS
if (typeof module !== 'undefined' && module.exports) {
  module.exports = abstractMethod;
}
